import { UserLocation, UserFilters, Property } from '../../interfaces/interfaces';
import createQuery from './elasticQueryBuilder';
//import propertyData from '../../utilities/properties274-Richmond.json';

/**
 * Searches Elastic Search - Gets Properties
 * @param userLocation (data needed for query to determine type and details of search)
 * @param userFilters (data needed for query to filter results based on user inputs)
 * @returns array of properties OR PromiseWithCancelInt to cancel the request
 */
const elasticUrl = '/elastic/listings/_search';

export async function getPropertiesFromElasticSearch(
	userLocation: UserLocation,
	filters: UserFilters,
	pageSize: number,
	pageNumber: number,
	propertyListSort: number,
): Promise<any> {
	//TODO: Make sure userLocation contains the search type geopoint vs term vs bounds vs polygon
	const queryForElasticSearch: any = createQuery(userLocation, filters, pageSize, pageNumber, propertyListSort);

	const requestOptions: RequestInit = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(queryForElasticSearch),
		redirect: 'follow',
	};

	try {
		const response = await fetch(elasticUrl, requestOptions);
		const propertyData = await response.json();
		//console.log('%c ES DATA: ', 'background: darkblue; color: white', propertyData?.hits?.hits?.length, propertyData?.hits?.total);
		return propertyData;
	} catch (error: unknown) {
		console.error('ES Search error');
	}
}

export async function getSinglePropertyByAddressFromElasticSearch(address: string) {
	const query = {
		query: { term: { 'AddressUrlString.keyword': address } },
		'sort': {
			'_script': {  // Note: Scripts should only be used for small datasets to avoid performance issues
				'type': 'number',
				'script': {
					'lang': 'painless',
					'source': 'long OnMarketDateValue = doc[\'OnMarketDate\'].size() == 0 ? Long.MIN_VALUE : doc[\'OnMarketDate\'].value.getMillis(); long DerivedOnMarketTimestampValue = doc[\'DerivedOnMarketTimestamp\'].size() == 0 ? Long.MIN_VALUE : doc[\'DerivedOnMarketTimestamp\'].value.getMillis(); return Math.max(OnMarketDateValue, DerivedOnMarketTimestampValue);'
				},
				'order': 'desc'
			}
		}
	};

	console.warn('ES SINGLE Query: ', query);

	const requestOptions: RequestInit = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Basic ${window.btoa('elastic:zO5J3RVoD2GOXd9FBcN36C4r')}`,
		},
		body: JSON.stringify(query),
		redirect: 'follow',
	};

	try {
		const response = await fetch(elasticUrl, requestOptions);
		const propertyRaw = await response.json();
		if (propertyRaw?.hits?.total?.value > 0) {
			const property: Property = propertyRaw?.hits?.hits?.map((jsonData: any) => ({
				...jsonData?._source,
				id: jsonData._id,
			}))[0];
			return property;
		} else {
			console.error('ES DATA Property Not Found: ', propertyRaw);
		}
	} catch (error: unknown) {
		console.warn('ES Single Property Problem', error);
	}
}

/**
 * Searches Elastic Search - Gets Properties
 * @param propertyId (data needed for query to determine type and details of search)
 * @returns array of properties
 */
export async function getSinglePropertyFromElasticSearch(propertyId: string, mlsId?: string): Promise<any> {
	const query: string =
    propertyId.length > 0
    	? `{"query": { "term": { "_id": "${propertyId}" }}}`
    	: `{"query": { "term": { "ListingId.keyword": "${mlsId}" }}}`;

	console.warn('ES SINGLE Query: ', query);

	const requestOptions: RequestInit = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Basic ${window.btoa('elastic:zO5J3RVoD2GOXd9FBcN36C4r')}`,
		},
		body: query,
		redirect: 'follow',
	};

	try {
		const response = await fetch(elasticUrl, requestOptions);
		const propertyRaw = await response.json();

		if (propertyRaw?.hits?.total?.value > 0) {
			//console.warn("ES SINGLE DATA: ", propertyRaw);
			// get the first result (should be only one)
			const property: Property = propertyRaw?.hits?.hits?.map((jsonData: any) => ({
				...jsonData?._source,
				id: jsonData._id,
			}))[0];
			return property;
		} else {
			console.error('ES DATA Property Not Found: ', propertyRaw);
		}
	} catch (error: unknown) {
		console.warn('ES Single Property Problem', error);
	}
}
